export default function Loader() {
  return (
    <div className="grid min-h-screen place-items-center bg-canvas dark:bg-night" role="status" aria-live="polite">
      <div className="h-12 w-12 animate-spin rounded-lg border-4 border-neutral border-t-primary shadow-hard-sm" />
      <span className="sr-only">Loading Tavio</span>
    </div>
  );
}
